function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "My-Tastings",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Noteable-/-Tasting-Tool-/-Desktop-/-Oak-Copy-5",
  transform: "translate(-908.000000, -457.000000)",
  stroke: "#391D4D",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(909.000000, 458.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "bin"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.2,6.5 L1.2,13.5 C1.2,14.605 1.916,15.5 2.8,15.5 L9.2,15.5 C10.084,15.5 10.8,14.605 10.8,13.5 L10.8,6.5",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.4,3.5 L11.6,3.5",
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "4.4 3.5 4.4 0.5 7.6 0.5 7.6 3.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.47692308,7.5 L7.47692308,12.5",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.52307692,7.5 L4.52307692,12.5",
  id: "Path"
})))))));

var SvgIconBin = function SvgIconBin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_bin.daf3142d.svg";
export { ForwardRef as ReactComponent };